// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "../../../../utils/index";
// import Form from "react-bootstrap/Form";
// import { useAuthHeaders } from "../../../../components/Token";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import CancelButton from "../../../../components/MinorComponents/CancelButton";

// function EditDescriptionType() {
//   const { _id } = useParams();
//   const [newEditDescriptionName, setNewEditDescriptionName] = useState("");
//   const [descriptionNameDetials, setDescriptionNameDetials] = useState("");
//   const navigate = useNavigate();
//   const headers = useAuthHeaders();
//   const slugname = localStorage.getItem("vendorsubdomain");
//   // const [categories, setCategories] = useState([]);
//   // const [selectedCategory, setSelectedCategory] = useState("");
//   // const [subCategory, setSubCategory] = useState([]);
//   // const [selectedSubCategory, setSelectedSubCategory] = useState("");

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/description/admin/singledescription/${_id}`)
//       .then((response) => {
//         setNewEditDescriptionName(response?.data?.description?.descriptionName);
//         console.log("response.data.description", response?.data?.description);
//         setDescriptionNameDetials(response?.data?.description);
//       })
//       .catch((error) => {
//         console.error("Error fetching category:", error);
//       });

//     // axios
//     //   .get(`${API_BASE_URL}/category/admin/getcategory`)
//     //   .then((response) => {
//     //     setCategories(response.data.categories);
//     //   })
//     //   .catch((error) => {
//     //     console.error("Error fetching category data:", error);
//     //   });
//   }, []);

//   const handleSave = (e) => {
//     e.preventDefault();
//     axios
//       .put(
//         `${API_BASE_URL}/description/admin/updatedescription/${_id}`,
//         {
//           descriptionName: newEditDescriptionName,
//           // subcategory: selectedSubCategory,
//           // category: selectedCategory,
//         },
//         {
//           headers,
//         }
//       )
//       .then((response) => {
//         navigate(`/${slugname}/master/description-name`);
//       })
//       .catch((error) => {
//         console.error("Error updating category:", error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response.data.error,
//         });
//       });
//   };



//   return (
//     <div className="p-3">
//       <h2>Edit Description Type</h2>
//       <form onSubmit={handleSave} className="category" style={{ boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset" }}>
//         <div className="row category-field">
//           <div className="d-flex align-items-center py-2">
//             <h5 className="m-0">Category :</h5>
//             <span className="mx-2">
//               {descriptionNameDetials.subcategory?.name}
//             </span>
//           </div>

//           <div className="d-flex align-items-center py-2">
//             <h5 className="m-0">Category :</h5>
//             <span className="mx-2">
//               {descriptionNameDetials?.category?.name}
//             </span>
//           </div>

//           <div className="col-md-4">
//             <label htmlFor="name" className="fs-6">
//               Change Description Type Name:
//             </label>
//             <br />
//             <input
//               type="text"
//               id="name"
//               value={newEditDescriptionName}
//               onChange={(e) => setNewEditDescriptionName(e.target.value)}
//             />
//           </div>

//           {/* <div className="col-md-4">
//             <label htmlFor="name" className="fs-6">
//               Category Name:
//             </label>
//             <br />
//             <Form.Select
//               id="category"
//               aria-label="Default select example"
//               className="my-2"
//               required
//               value={selectedCategory}
//               onChange={handleCategorySelect}
//             >
//               <option value="">Select a category</option>
//               {categories.map((category) => (
//                 <option key={category._id} value={category.name}>
//                   {category.name}
//                 </option>
//               ))}
//             </Form.Select>
//           </div>

//           <div className="col-md-4">
//             <label htmlFor="name" className="fs-6">
//               Change Sub Category Name:
//             </label>
//             <br />
//             <Form.Select
//               id="category"
//               aria-label="Default select example"
//               className="my-2"
//               value={selectedSubCategory}
//               required
//               onChange={(e) => setSelectedSubCategory(e.target.value)}
//             >
//               <option value="">Select a Sub Category</option>
//               {Array.isArray(subCategory) ? (
//                 subCategory.map((category) => (
//                   // console.log("sebcategory test :", category)
//                   <option key={category._id} value={category.name}>
//                     {category.name}
//                   </option>
//                 ))
//               ) : (
//                 <option value="">Loading subcategories...</option>
//               )}
//             </Form.Select>
//           </div> */}
//         </div>

//         <div className="buttons">
//           <button type="submit" style={{ backgroundColor: "#0443C0", color: "white" }}>Save</button>

//           <CancelButton path="/descriptionType" />
//         </div>
//       </form>
//     </div>
//   );
// }

// export default EditDescriptionType;
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import CancelButton from "../../../../../components/MinorComponents/CancelButton";
import { GETSingleDES, UpdateDESVendor } from "../../../../../services/api/Descriptions";

function EditDescriptionVendorType() {
  const { _id } = useParams();
  const navigate = useNavigate();
  const slugname = localStorage.getItem("vendorsubdomain");

  const [descriptionData, setDescriptionData] = useState({});
  const [newEditDescriptionName, setNewEditDescriptionName] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  useEffect(() => {
    fetchDescriptionData();
  }, [_id]);

  const fetchDescriptionData = async () => {
    try {
      const response = await GETSingleDES(slugname, _id);


      const desc = response?.description;
      setDescriptionData(desc);
      setNewEditDescriptionName(desc?.descriptionName || "");
    } catch (error) {
      console.error("Error fetching description:", error);
      setSnackbar({ open: true, message: "Failed to load data", severity: "error" });
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const response = await UpdateDESVendor(slugname, { descriptionName: newEditDescriptionName }, _id);
      if (response.success) {

        setSnackbar({ open: true, message: response.message, severity: "success" });
        setTimeout(() => navigate(`/${slugname}/master/description-name`), 1000);
      } else {
        setSnackbar({
          open: true,
          message: response?.data?.message || "Update failed",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Update error:", error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.error || "Update failed",
        severity: "error",
      });
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Edit Description Type
      </Typography>

      <Paper
        component="form"
        onSubmit={handleSave}
        sx={{ p: 3, boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset", backgroundColor: "#f9f9f9" }}
      >
        <Box display="flex" flexDirection="column" gap={2}>
          <Box>
            <Typography variant="subtitle1">
              <strong>Subcategory:</strong> {descriptionData?.subcategory?.name || "—"}
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1">
              <strong>Category:</strong> {descriptionData?.category?.name || "—"}
            </Typography>
          </Box>

          <TextField
            label="Change Description Name"
            variant="outlined"
            size="small"
            fullWidth
            required
            value={newEditDescriptionName}
            onChange={(e) => setNewEditDescriptionName(e.target.value)}
          />

          <Box mt={2} display="flex" gap={2}>
            <Button
              type="submit"
              variant="contained"
              sx={{ backgroundColor: "#0443C0", "&:hover": { backgroundColor: "#0333a0" } }}
            >
              Save
            </Button>
            <CancelButton path={`/${slugname}/master/description-name`} />
          </Box>
        </Box>
      </Paper>

      {/* Snackbar for feedback */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default EditDescriptionVendorType;
